import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const useOrderNumbers = (enabled?: boolean) => {
  const api = useAPI();

  return useQuery({
    queryKey: ['order-numbers'],
    queryFn: () =>
      api
        .postBackOrdersListFilter({
          postBackOrdersListFilterRequest: {
            data: {},
          },
        })
        .then((res) => res.result.data),
    enabled,
  });
};
